import { useResource } from '@common/hooks/useResources';
import transform, { SpeakerResource } from '@common/transforms/speaker';

export const useSpeaker = (speakerId?: string) => {
  return useResource<SpeakerResource>('speaker', speakerId, transform.one);
};
